// @ts-expect-error TS(2307): Cannot find module './Icons/icomoon.ttf' or its co... Remove this comment to see the full error message
import IconMoonTtf from './Icons/icomoon.ttf';
// @ts-expect-error TS(2307): Cannot find module './Icons/icomoon.woff' or its c... Remove this comment to see the full error message
import IconMoonWoff from './Icons/icomoon.woff';
import IconMoonSvg from './Icons/icomoon.svg';

import { SORT_DIRECTION } from 'constants/table';

const { ASCENDING, DESCENDING } = SORT_DIRECTION;

const iconsFontFace = `
    @font-face {
        font-family: 'icomoon';
        src: url('${IconMoonTtf}?rmyxbe') format('truetype'),
            url('${IconMoonWoff}?rmyxbe') format('woff'),
            url('${IconMoonSvg}?rmyxbe#icomoon') format('svg');
        font-style: normal;
    }

    [class^="icon-"], [class*=" icon-"] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: 'icomoon' !important;
        speak: none;
        font-style: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;

      /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .icon-account-circle:before {
      content: "\\e901";
    }
    .icon-domain:before {
      content: "\\e902";
    }
    .icon-notification:before {
      content: "\\e903";
    }
    .icon-oval-tool:before {
      content: "\\e904";
    }
    .icon-polygon-tool:before {
      content: "\\e905";
    }
    .icon-edit:before {
      content: "\\e906";
    }
    .icon-search:before {
      content: "\\e907";
    }
    .icon-check:before {
      content: "\\e908";
    }
    .icon-close-heavy:before {
        content: "\\e909";
    }
    .icon-close-light:before {
      content: "\\e90a";
    }
    .icon-caret-left:before {
        content: "\\e90b";
    }
    .icon-caret-right:before {
        content: "\\e90c";
    }
    .icon-caret-left-light:before {
      content: "\\e90d";
    }
    .icon-caret-right-light:before {
      content: "\\e90e";
    }
    .icon-caret-up:before {
      content: "\\e90f";
    }
    .icon-caret-down:before {
      content: "\\e910";
    }
    .icon-caret-up-light:before {
      content: "\\e911";
      display: inline-block;
      min-width: 14px;
    }
    .icon-caret-down-light:before {
      content: "\\e912";
      display: inline-block;
      min-width: 14px;
    }
    .icon-drag:before {
        content: "\\e913";
    }
    .icon-sort:before {
        content: "\\e914";
    }
    .icon-sort_up:before, .icon-sort-${ASCENDING}:before {
      content: "\\e915";
    }
    .icon-sort_down:before, .icon-sort-${DESCENDING}:before{
      content: "\\e916";
    }
    .icon-radio_button_off:before {
        content: "\\e917";
    }
    .icon-radio_button_on:before {
        content: "\\e918";
    }
    .icon-calendar:before {
        content: "\\e919";
    }
    .icon-car-connected:before {
        content: "\\e91a";
    }
    .icon-car-disconnected:before {
        content: "\\e91b";
    }
    .icon-refresh:before {
        content: "\\e91c";
    }
    .icon-alert:before {
        content: "\\e91d";
    }
`;

export default iconsFontFace;
